<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.invoice.createBatchInvoice')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <!-- Create Invoice Form -->
                <div class="card" v-show="step === 1">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.invoice.createBatchInvoice')}}</div>
                        <button class="btn btn-primary float-right" @click="generate()"
                            :disabled="submit === 'pending'">{{$t('button.generate')}}</button>
                    </div>

                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.programType')}}<span class="text-danger">*</span></label>
                                    <v-select @input="programTypeSelected" label="FullTitle" :options="programs"
                                        v-model="programType" :reduce="programs => programs"></v-select>
                                    <div class="invalid-feedback custom-validate" v-if="invalidProgram">
                                        {{$t('form.validation.required')}}</div>
                                </div>

                                <!-- <div class="form-group" v-if="programType.BillingCycle == 'course'">
                                    <label>{{$t('form.invoice.courses')}}</label>
                                    <v-select label="FullTitle" @input="selectedCourse" :options="courses"
                                        v-model.trim="course" :reduce="courses => courses">
                                    </v-select>
                                </div>

                                <div class="form-group" v-else-if="programType.BillingCycle == 'term'">
                                    <label>{{$t('form.invoice.terms')}}</label>
                                    <v-select :options="semesters" @input="selectedSemester" v-model.trim="term"
                                        :reduce="semesters => semesters"></v-select>
                                </div> -->

                                <div class="form-group">
                                    <label>{{$t('form.invoice.invoiceDate')}}<span class="text-danger">*</span></label>
                                    <date-picker :lang="lang" class="date-picker" v-model="date" valueType="format"
                                        :format="dateFormat" :popup-style="{ top: '100%', left: 0}"
                                        :append-to-body="false">
                                    </date-picker>
                                    <div class="invalid-feedback d-block" v-if="invalidDate">
                                        {{$t('form.validation.required')}}</div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t('form.invoice.dueDate')}}<span class="text-danger">*</span></label>
                                    <date-picker :lang="lang" class="date-picker" v-model="dueDate" valueType="format"
                                        :format="dateFormat" :popup-style="{ top: '100%', left: 0}"
                                        :append-to-body="false">
                                    </date-picker>
                                    <div class="invalid-feedback d-block" v-if="invalidDueDate">
                                        {{$t('form.validation.required')}}</div>
                                </div>

                                <div class="form-group">
                                    <b-form-checkbox id="checkbox-1" v-model="sendInvoice">
                                        {{$t('form.invoice.sendInvoice')}}
                                    </b-form-checkbox>
                                </div>

                                <div class="form-group" v-if="sendInvoice">
                                    <label>{{$t('form.invoice.scheduledDeliveryDate')}}</label>
                                    <date-picker :lang="lang" class="date-picker" v-model="deliveryDate" valueType="format"
                                        type="datetime" :format="datetimeFormat" :popup-style="{ top: '100%', left: 0}"
                                        :append-to-body="false">
                                    </date-picker>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>{{$t('form.invoice.amount')}}<span class="text-danger">*</span></label>
                                    <input v-model.trim="$v.amount.$model" :class="{ 'is-invalid': $v.amount.$error }"
                                        type="text" class="form-control">

                                    <div class="invalid-feedback" v-if="!$v.amount.required">
                                        {{$t('form.validation.required')}}</div>

                                    <div class="invalid-feedback" v-if="!$v.amount.decimal">
                                        {{$t('form.validation.decimalAllowed')}}</div>

                                    <p class="text-muted" v-if="discount > 0">
                                        {{$t('form.invoice.globalDiscountInfo', {discount: discount})}}</p>
                                </div>


                                <div class="form-group">
                                    <b-form-checkbox id="exclude_scholarship_reduction"
                                    :disabled="!programType.name" v-model="exclude_scholarship_reduction">
                                            {{$t('form.invoice.exclude_scholarship_reduction')}}
                                    </b-form-checkbox>
                                </div>

                                <div class="form-group" v-if="tuition_fee_cycle=='course'">
                                    <label>{{$t('form.invoice.course')}}</label>
                                    <v-select label="FullTitle" @input="selectedCourse" :options="courses"
                                        v-model.trim="course" :reduce="courses => courses">
                                    </v-select>
                                </div>

                                <div class="form-group" v-else-if="tuition_fee_cycle=='term'">
                                    <label>{{$t('form.invoice.terms')}}</label>
                                    <v-select :options="semesters"  :value="currentsemester" @input="selectedSemester($event)"
                                        :reduce="semesters => semesters"></v-select>
                                </div>
             
                                <div class="form-group">
                                    <label>{{$t('form.invoice.currency')}}<span class="text-danger">*</span></label>

                                    <v-select :options="currencies" v-model.trim="currency"
                                        :reduce="currencies => currencies"></v-select>

                                    <div class="invalid-feedback custom-validate" v-if="invalidCurrency">
                                        {{$t('form.validation.required')}}</div>
                                </div>

                                <div class="form-group">
                                    <label>{{$t('form.invoice.invoicePurpose')}}<span class="text-danger">*</span></label>
                                    <v-select :options="invoicePurposes" v-model="invoicePurpose"
                                        :reduce="invoicePurposes => invoicePurposes">
                                    </v-select>


                                    <div class="d-flex justify-content-between mt-2">
                                        <b-form-input v-model="newPurpose" :placeholder="$t('form.invoice.newPurpose')">
                                        </b-form-input>
                                        <b-button class="ml-2" variant="light" @click="addPurpose">{{$t('button.save')}}
                                        </b-button>
                                    </div>

                                </div>

                                <!-- <div class="form-group">
                                    <label>{{$t('form.invoice.mailAddress')}}</label><br>
                                    <b-form-radio v-model="mailAddress" value="1">{{$t('form.invoice.personalAddress')}}
                                    </b-form-radio>
                                    <b-form-radio v-model="mailAddress" value="2">{{$t('form.invoice.businessAddress')}}
                                    </b-form-radio>
                                </div> -->
                            </div>
                            <div class="col-md-12" v-if="students.length">
                                <hr>
                                <div class="d-flex justify-content-start">
                                    <label>{{$t('form.invoice.selectStudents')}}</label>
                                    <input type="checkbox" @change="toggleCheck" class="mt-1 ml-1">
                                </div>
                                <div class="form-group row">
                                    <label v-for="(student, index) in students" :key="index"
                                        class="form-check-label custom-label col-2">
                                        <input type="checkbox" v-model="selectedStudents" :value="student">
                                        {{student.FirstName }} {{student.LastName }}
                                    </label>
                                </div>
                            </div>
                            <p class="col-md-12 p-3 m-0" v-if="noStudentFlag">{{$t('form.notification.noStudentFoundUnderType')}}
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Invoice(s) List -->
                <div class="card" v-show="step === 2">
                    <div class="card-header bg-light">
                        <div class="card-title">{{$t('form.invoice.batchInvoicesList')}}</div>
                        <div class="d-flex justify-content-end">
                            <b-button @click="goBack" class="mr-2">{{$t('button.goBack')}}</b-button>
                            <b-button variant="primary" @click="saveInvoices">{{$t('button.save')}}</b-button>
                        </div>
                    </div>
                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover" v-if="invoices.length">
                            <thead>
                                <tr>
                                    <th>{{$t('form.invoice.number')}}</th>
                                    <!-- <th>{{$t('form.invoice.studentNumber')}}</th> -->
                                    <th>{{$t('form.invoice.student')}}</th>
                                    <th>{{$t('form.invoice.date')}}</th>
                                    <th>{{$t('form.invoice.dueDate')}}</th>
                                    <th>{{$t('form.invoice.amount')}}</th>
                                    <th>{{$t('form.invoice.invoicePurpose')}}</th>
                                    <!-- <th>{{$t('form.invoice.paid')}}</th> -->
                                    <th class="text-right">{{$t('form.invoice.action')}}</th>
                                </tr>
                            </thead>
                            <tbody v-for="(invoice, index) in invoices" :key="index">
                                <tr @dblclick="showEditModal(index)">
                                    <td>{{invoice.InvoiceNumber}}</td>
                                    <td>{{invoice.StudentID}}</td>
                                    <!-- <td>{{invoice.Name}}</td> -->
                                    <td>{{invoice.InvoiceDate}}</td>
                                    <td>{{invoice.DueDate}}</td>
                                    <td>
                                        <template v-if="invoice.Discount > 0 && exclude_scholarship_reduction != true">
                                            <!-- <del>{{invoice.Currency}}
                                                {{invoice.Amount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}</del> -->
                                            {{invoice.Currency}}
                                            {{invoice.DiscountedAmount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}
                                            ({{invoice.Discount}}% {{$t('form.invoice.discount')}})
                                        </template>
                                        <template v-else>
                                            {{invoice.Currency}}
                                            {{invoice.Amount | curreny(decimalDigits, decimalPoint, thousandSeparator)}}
                                        </template>
                                    </td>
                                    <td v-if="invoicePurpose">{{invoicePurpose}}</td>
                                    <td v-else-if="newPurpose">{{newPurpose}}</td>
                                    <!-- <td>{{invoice.Paid == -1 ? 'Yes' : 'No'}}</td> -->
                                    <td class="text-right">
                                        <button v-if="permissions.editInvoicesStudents" @click="showEditModal(index)"
                                            class="btn btn-info btn-sm">
                                            <i class="fa fa-edit"></i>
                                        </button>
                                        <button @click="removeInvoice(index)" class="btn btn-danger btn-sm">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                    </div>
                </div>

                <!-- Edit Invoice Modal -->
                <b-modal id="editInvoiceModal" size="lg">

                    <template v-slot:modal-title>
                        <p v-html="$t('form.invoice.editing', {name: editInvoice.Name})"></p>
                    </template>

                    <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                    <div class="form-group">
                        <label>{{$t('form.invoice.amount')}}<span class="text-danger">*</span></label>

                        <input v-model.trim="$v.editInvoice.Amount.$model"
                            :class="{ 'is-invalid': $v.editInvoice.Amount.$error }" type="text" class="form-control">

                        <div class="invalid-feedback" v-if="!$v.editInvoice.Amount.decimal">
                            {{$t('form.validation.decimalAllowed')}}</div>
                        <p class="text-muted" v-if="editInvoice.Discount > 0">
                            {{$t('form.invoice.globalDiscountInfo', {discount: editInvoice.Discount})}}</p>
                    </div>

                    <div class="form-group" v-if="editInvoice.Discount > 0">
                        <label>{{$t('form.invoice.discountedAmount')}}</label>
                        <input :value="editInvoice.DiscountedAmount" type="text" class="form-control" readonly>
                    </div>

                    <div class="form-group">
                        <label>{{$t('form.invoice.invoiceDate')}} <span class="text-danger">*</span></label>
                        <date-picker :lang="lang" class="date-picker" v-model="editInvoice.InvoiceDate" valueType="format"
                            :format="dateFormat" :popup-style="{ top: '100%', left: 0}" :append-to-body="false">
                        </date-picker>
                        <div class="invalid-feedback custom-validate" v-if="invalidDate">
                            {{$t('form.validation.required')}}</div>
                    </div>

                    <template v-slot:modal-footer="{ ok, cancel }">
                        <b-button @click="cancel()">
                            {{$t('button.close')}}
                        </b-button>
                        <b-button variant="primary" @click="updateInvoice()">
                            {{$t('button.save')}}
                        </b-button>
                    </template>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        required,
        maxLength,
        decimal
    } from "vuelidate/lib/validators";

    export default {
        props: ['permissions', 'dateFormat', 'datetimeFormat', 'decimalDigits', 'decimalPoint', 'thousandSeparator'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                partnerId:1,
                batchInvoiceStatus:true,
                ActivePaymentPlan:'active',

                tuition_semesters:[],
                isLoading: false,
                fullPage: true,
                currentsemester:null,
                current_page:1,
                tuition_fee_cycle:null,
                invalidCurrency: false,
                invalidProgram: false,
                invalidDate: false,
                invalidDueDate: false,
                submit: 'ok',
                step: 1,
                newPurpose: null,

                selectedStudents:[],
                lang: {
                    formatLocale: {
                        firstDayOfWeek: 1,
                    },
                },
                programID: null,
                programType: {
                    FullTitle: null,
                    created_at: null,
                    id: null,
                    name: null,
                    type: null,
                    updated_at:null,
                },
                amount: null,
                defaultAmount: null,
                currency: null,
                date: moment().format(this.dateFormat),
                dueDate: null,
                invoiceNumber: 0,
                deliveryDate: null,
                sendInvoice: false,
                course: null,
                semester: null,
                invoicePurpose: null,
                mailAddress: 1,
                exclude_scholarship_reduction:null,

                noStudentFlag: 0,
                discount: 0,
                editInvoice: {},
                editingInvoiceIndex: null,
                dueDateDuration: 0,

                invoice: {
                    StudentID: null,
                    InvoicePurpose: null,
                    InvoiceNumber: null,
                    Amount: null,
                    Currency: null,
                    InvoiceDate: null,
                    DueDate: null,
                    PaymentDate: null,
                    Paid: null,
                    Discount: 0,
                    DiscountedAmount: 0,
                    excludeScholarshipReduction: null,
                },
                dropdown:1,
                tuitionFee:{},
                programs: [],
                students: [],
                currencies: [],
                invoices: [],
                courses: [],
                semesters: [],
                invoicePurposes: [],
            }

        },

        validations: {
            amount: {
                required,
                decimal
            },

            date: {
                required
            },

            dueDate: {
                required
            },

            currency: {
                required
            },

            programType: {
                FullTitle: {
                    required
                }
            },

            editInvoice: {
                Amount: {
                    decimal
                },
                InvoiceDate: {

                },
            }
        },

        mounted() {
            if (!this.permissions.createInvoicesBatch) {
                return this.$router.push('/');
            }

            this.getInitialData();
            this.getPrograms();
        },

        methods: {
            fetchCourses() {
                this.isLoading = true;

                axios
                    .get(`/api/program-type-courses?programType=${this.programType.name}`)
                    .then(response => {

                     
                            var arrayToBepopulated = [];
                            var temp= response.data;
                            arrayToBepopulated.push(temp[0])
                            var courseCodes=[];
                            courseCodes.push(temp[0].CourseCode)
                            // exit_loops:
                            for(var i=0;i<temp.length;i++){
                               for(var j=0;j<arrayToBepopulated.length;j++){
                                   if((temp[i].CourseCode!=arrayToBepopulated[j].CourseCode) && !courseCodes.includes(temp[i].CourseCode) && !(arrayToBepopulated.includes(temp[i]))){
                                        arrayToBepopulated.push(temp[i])
                                    }
                                     if(!(courseCodes.includes(temp[i].CourseCode))){
                                    courseCodes.push(temp[i].CourseCode)
                                    }
                               }
                            }
                            this.courses=arrayToBepopulated;
                            this.courses.map(c => {
                            c.Semester = c.Semester;
                            })
                  

                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log('error');
                        this.isLoading = false;
                    });
            },
            selectedSemester(semester) {
                
                this.currentsemester=semester;
                if (!semester) {
                    if(!this.program && (this.studentName=='' || this.studentName==null)){
                    this.invoice.InvoicePurpose = null;
                    this.invoice.Amount = this.defaultAmount;
                    }else{
                        this.getProgramTypeTuitionFee();
                    }
                }
                 if (semester) {
                // set amount
                if(this.tuition_fee_cycle=='term'){
                    for(var i=0;i<this.tuitionFee.sem_fees.length;i++){
                       if(semester==this.tuitionFee.sem_fees[i].semester_no){
                           this.invoice.Amount = this.tuitionFee.sem_fees[i].tuition_fee;
                           this.amount = this.invoice.Amount;
                       }
                    }
                    
                }

                //  set invoice purpose for selected course
                let purpose = this.$t('form.invoice.termPurposeBatch', {
                    semester: semester,
                    programType: this.programType.name
                });

                // if (!this.invoicePurposes.includes(purpose)) {
                //     this.invoicePurposes.unshift(purpose);
                // }

                this.invoicePurpose = purpose;
                 }
            },
        selectedCourse(course) {
                try {
                if (!course) {
                    if(!this.programType){
                    this.invoice.InvoicePurpose = null;
                    this.amount = this.defaultAmount;
                    }else{
                        this.getProgramTypeTuitionFee();
                    }
                }
                if(course){
            
                if(this.tuition_fee_cycle=='course'){
                   this.invoice.Amount = this.tuitionFee.course_fee;
                   this.amount = this.invoice.Amount
                }
                // set invoice purpose for selected course
                let purpose = this.$t('form.invoice.coursePurposeBatch', {
                    course: course.CourseTitle,
                    programType: this.programType.name
                });

                // if (!this.invoicePurposes.includes(purpose)) {
                //     this.invoicePurposes.unshift(purpose);
                // }

                this.invoicePurpose = purpose
                }
            } catch (error) {
                console.log('error');
            }
                
            },
            
            addPurpose() {
                if (!this.newPurpose) {
                    return;
                }

                if (!this.invoicePurposes.includes(this.newPurpose)) {
                    this.invoicePurposes.unshift(this.newPurpose);
                    this.saveInvoicePurposes();
                }

                this.InvoicePurpose = this.newPurpose;

                this.newPurpose = null;
            },

            getInitialData() {
                this.isLoading = true;

                axios
                    .get('/api/invoices/get-initial-data')
                    .then(response => {
                        this.isLoading = false;
                        this.currencieresponses = response.data.currencies;
                        this.invoiceNumber = response.data.invoice_number;
                        this.amount = response.data.amount;
                        this.defaultAmount = response.data.amount;
                        this.currency = response.data.default_currency;
                        this.dueDateDuration = response.data.due_date_duration;
                        this.invoicePurposes = response.data.invoice_purposes;

                        this.dueDate = moment(this.getDueDate(this.dueDateDuration)).format(this.dateFormat);
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            getPrograms() {
                this.isLoading = true;

                axios
                    .get(`/api/program-codes-types?type=type&dropdown=${this.dropdown}`)
                    .then(response => {
                        this.programs = response.data.data;
                        this.programs.map(p => p.FullTitle = `${p.name}`);

                        this.isLoading = false;
                    })
                    .catch(error => {
                        console.log('error');
                        this.isLoading = false;
                    });
            },

            programTypeSelected() {
                if (!this.programType) {
                    this.programType = {
                        FullTitle: null,
                        created_at: null,
                        id: null,
                        name: null,
                        type: null,
                        updated_at:null,
                    };

                    this.students = [];
                    this.amount = this.defaultAmount;
                    return;
                }
                this.getStudents();
            },
            getProgramTypeTuitionFee() {
                this.isLoading = true;
                axios
                    .post(`/api/tuitionfees/type-tuition-fee?name=${this.programType.name}`)
                    .then(response => {
                        this.isLoading = false;
                        this.tuitionFee = {};
                        this.tuition_fee_cycle=response.data[0].billing_cycle;
                        this.amount=response.data[0].fee_to_apply;
                        this.tuitionFee=response.data[0].tuition_fee;
                         if(this.tuition_fee_cycle=='term'){
                        for(var i=0;i<this.tuitionFee.sem_fees.length;i++){
                            this.tuition_semesters.push(this.tuitionFee.sem_fees[i].semester_no);
                        }
                        this.semesters = this.tuition_semesters;
                        }else if(this.tuition_fee_cycle=='course'){
                            this.fetchCourses();
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },
            getStudents() {
                this.isLoading = true;

                axios
                    .get(`/api/students?page=${this.current_page}&programType=${this.programType.FullTitle}&partnerId=${this.partnerId}&batchInvoiceStatus=${this.batchInvoiceStatus}&ActivePaymentPlan=${this.ActivePaymentPlan}`)
                    .then(response => {
                        this.isLoading = false;

                        this.students = [];
                        this.students=response.data.data.data
                        this.noStudentFlag = this.students.length == 0 ? true : false;
                        this.getProgramTypeTuitionFee();

                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },
            async generate() {
                this.$v.$touch();
                this.invalidCurrency = this.currency == null ? true : false;
                this.invalidProgram = this.programType.FullTitle == null ? true : false;
                this.invalidDate = this.date == null ? true : false;
                this.invalidDueDate = this.dueDate == null ? true : false;
                
                if(this.newPurpose == '')
                this.newPurpose = null;
                if(this.invoicePurpose == '')
                this.invoicePurpose = null;

                if (this.$v.$invalid || (this.invoicePurpose == null && this.newPurpose == null)) {
                  
                    let errorMsg = '';

                    if(this.$v.amount.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.amount'): this.$t('form.invoice.amount');
                    };

                    if(this.$v.currency.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.currency'): this.$t('form.invoice.currency');
                    };


                    if(this.$v.date.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.invoiceDate'): this.$t('form.invoice.invoiceDate');
                    };

                    if(this.$v.dueDate.$error){
                        errorMsg = errorMsg ? errorMsg +", "+this.$t('form.invoice.dueDate'):this.$t('form.invoice.dueDate');
                    };                    

                    if(this.$v.programType.FullTitle.$error){
                        errorMsg = errorMsg ? errorMsg +", "+ this.$t('form.invoice.programType'):this.$t('form.invoice.programType');
                    };

                    if(this.invoicePurpose == null && this.newPurpose == null){
                        errorMsg = errorMsg ? errorMsg +", "+ this.$t('form.invoice.invoicePurpose'):this.$t('form.invoice.invoicePurpose');
                    }

                    this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');

                    this.$v.$reset();

                    return;
             
                }
                
                if (this.students.length <= 0) {
                    this.showAlert(this.$t('form.validation.noStudents'), 'danger');
                    return;
                }
                if(this.newPurpose && this.invoicePurpose){
                    if(confirm(this.$t('form.invoice.purposeOverwrittenWarning'))){

                    this.invoice.InvoicePurpose = this.invoicePurpose ? this.invoicePurpose :this.newPurpose;
                    this.newPurpose = null;

                    }
                    else{

                        return;

                    }
                }else{
                    this.invoice.InvoicePurpose = this.invoicePurpose ? this.invoicePurpose :this.newPurpose;
                }
                this.submit = 'pending';
                this.isLoading = true;
                await this.makeInvoices();
                this.isLoading = false;
            },

            async makeInvoices() {
                this.selectedStudents.forEach(student => {
                    if (student) {

                        var discountedAmount = null;
                        if(this.exclude_scholarship_reduction != true && student.GlobalDiscount && student.GlobalDiscount > 0){
                        discountedAmount = this.getDiscountedAmount(student.GlobalDiscount);
                        }
                        else{
                        discountedAmount = this.amount
                        }

                        this.invoices.push({
                            StudentID: student.ID,
                            InvoicePurpose: null,
                            InvoiceNumber: this.invoiceNumber,
                            Amount: this.amount,
                            Discount: student.GlobalDiscount,
                            DiscountedAmount: discountedAmount,
                            Currency: this.currency,
                            InvoiceDate: this.date,
                            DueDate: this.dueDate,
                            PaymentDate: null,
                            Paid: 0,
                            InvoicePurpose: this.newPurpose ? this.newPurpose : this.invoicePurpose,
                            StudentNumber: student.number,
                            Name: student.name,
                            MailAddress: this.mailAddress,
                            DeliveryDate: this.deliveryDate,
                            sendInvoice: this.sendInvoice,
                            excludeScholarshipReduction: this.exclude_scholarship_reduction
                        });
                        this.invoiceNumber++;
                    }
                });

                await this.validateInvoices();
            },

            getDueDate(days, format = 'YYYY-MM-DD') {
                days = parseInt(days);
                return moment().add(days, 'days').format(format);
            },

            removeInvoice(index) {
                let conf = confirm(this.$t('form.validation.delete'));

                if (conf) {
                    this.invoices.splice(index, 1);
                    this.showAlert(this.$t('form.invoice.remove'));
                }
            },

            showEditModal(index) {
                this.editInvoice = {
                    ...this.invoices[index]
                };

                this.editingInvoiceIndex = index;
                this.$bvModal.show('editInvoiceModal');
            },

            updateInvoice() {
                // calculate discount again
                let discountedAmount = this.getDiscountedAmount(this.editInvoice.Discount, this.editInvoice.Amount);
                this.editInvoice.DiscountedAmount = discountedAmount;

                this.invoices[this.editingInvoiceIndex] = {
                    ...this.editInvoice
                };
                this.$bvModal.hide('editInvoiceModal');
                this.editInvoice = {};
            },

            getDiscountedAmount(discount = 0, amount = null) {
                let discountedAmount = 0;
                let value = amount ? amount : this.amount;

                if (discount > 0 && discount <= 100) {
                    discountedAmount = value - (value * discount / 100);
                }

                return discountedAmount;
            },

            validateInvoices() {
                if (this.invoices.length > 0) {
                    this.step = 2;
                    this.submit = 'ok';
                    this.clear();
                    return;
                }

                this.showAlert(this.$t('form.validation.noStudents'), 'danger');
                this.goBack();
                this.submit = 'error';
            },

            saveInvoices() {
                this.isLoading = true;

                let data = new FormData();

                this.invoices.forEach(invoice => data.append('invoices[]', JSON.stringify(invoice)),course=>this.course,term=>this.term);
                console.log(this.invoices);

                axios
                    .post('/api/invoices', data)
                    .then(response => {
                        this.isLoading = false;

                        if (response.data.success) {
                            this.showAlert(response.data.message);
                            this.saveInvoicePurposes();

                            setTimeout(() => {
                                this.$router.push({
                                    name: 'StudentInvoiceIndex'
                                });
                            }, 2000);
                        }

                        if (response.data.error) {
                            this.showAlert(response.data.message, 'danger');
                            this.isLoading = false;
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            saveInvoicePurposes() {
                axios
                    .post("/api/settings?name=invoice-purposes", {
                        value: this.invoicePurposes
                    })
                    .then(response => {})
                    .catch(error => {});
            },

            toggleCheck(event) {
                if (event.target.checked) {
                    this.selectedStudents=this.students
                } else {
                    this.selectedStudents=[]
                }
            },

            clear() {
                this.alert = false;
                this.alertClass = '';
                this.alertMessage = '';
                // this.programID = null;
                // this.amount = null;
                // this.currency = null;
                // this.date = moment().format('YYYY-MM-DD');
                // this.students = [];
                // this.$v.$reset();
                // this.submit = 'ok';
            },

            goBack() {
                this.invoices = [];
                this.step = 1;
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    }

</script>
<style scoped>
    .custom-validate {
        display: block !important;
    }

    #editInvoiceModal___BV_modal_outer_ {
        z-index: 999 !important;
    }

</style>
